module.exports = __webpack_public_path__ + "static/media/avatar_hombre-3.7e9904d5.svg";